<div class="theme-switcher">
  <h4 class="theme-switcher-title">Theme</h4>
  <div class="theme-options">
    <button
      *ngFor="let theme of themes"
      class="btn btn-ghost btn-sm theme-option"
      [class.theme-option-active]="isActive(theme.id)"
      (click)="onThemeChange(theme.id)"
    >
      <div class="theme-preview" [style.background]="theme.brandColors?.primary"></div>
      <span>{{ theme.displayName }}</span>
    </button>
  </div>
</div>
